import React, { useEffect, useState } from 'react';
import { Stack } from '@fluentui/react';

import { useAuth0 } from '@auth0/auth0-react';
import jwt_decode from 'jwt-decode';
import { returnFluentIcon } from '../../utils';
import Separator from './Separator';
import NavItem from './NavItem';

interface INavbarItem {
  key: string;
  icon: string;
  disableHover: boolean;
  isFavorite: boolean;
  href: string;
  text: string;
  isSeparator: boolean;
  permission?: string;
  permissions?: string[];
}

const NavbarItems: INavbarItem[] = [
  {
    key: '1',
    icon: 'Home',
    disableHover: true,
    isFavorite: false,
    href: '/start',
    text: 'Dashboard',
    isSeparator: false,
  },
  {
    key: '2',
    icon: 'StackIndicator',
    disableHover: false,
    isFavorite: false,
    href: '',
    text: 'Verkoop',
    isSeparator: true,
    permissions: [
      'nav:leads',
      'nav:logItems',
      'nav:quoteReferences',
    ],
  },
  {
    key: '21',
    icon: 'People',
    disableHover: false,
    isFavorite: false,
    href: '/leads',
    text: 'Prospecten',
    isSeparator: false,
    permission: 'nav:leads',
  },
  {
    key: '22',
    icon: 'People',
    disableHover: true,
    isFavorite: false,
    href: '/log-items',
    text: 'Log items',
    isSeparator: false,
    permission: 'nav:logItems',
  },
  {
    key: '23',
    icon: 'People',
    disableHover: true,
    isFavorite: false,
    href: '/quotes',
    text: 'Offertes',
    isSeparator: false,
    permission: 'nav:quoteReferences',
  },
  {
    key: '3',
    icon: 'StackIndicator',
    disableHover: false,
    isFavorite: false,
    href: '',
    text: 'Werfopvolging',
    isSeparator: true,
    permissions: [
      'nav:constructionSites',
      'nav:purchaseOrders',
    ],
  },
  {
    key: '31',
    icon: 'People',
    disableHover: false,
    isFavorite: false,
    href: '/construction-sites',
    text: 'Werven',
    isSeparator: false,
    permission: 'nav:constructionSites',
  },
  {
    key: '32',
    icon: 'People',
    disableHover: false,
    isFavorite: false,
    href: '/purchase-orders',
    text: 'Bestelbonnen',
    isSeparator: false,
    permission: 'nav:purchaseOrders',
  },
  {
    key: '4',
    icon: 'StackIndicator',
    disableHover: false,
    isFavorite: false,
    href: '',
    text: 'Naverkoop',
    isSeparator: true,
    permissions: [
      'nav:defectWorkOrders',
    ],
  },
  {
    key: '41',
    icon: 'People',
    disableHover: true,
    isFavorite: false,
    href: '/work-orders',
    text: 'Werkbonnen',
    isSeparator: false,
    permission: 'nav:defectWorkOrders',
  },
  {
    key: '5',
    icon: 'StackIndicator',
    disableHover: false,
    isFavorite: false,
    href: '',
    text: 'Boekhouding',
    isSeparator: true,
    permissions: [
      'nav:customers',
      'nav:customerPaymentTransactions',
      'nav:customerContractUpdates',
      'nav:customerInvoices',
      'nav:suppliers',
      'nav:customerInvoices',
      'nav:costCenters',
    ],
  },
  {
    key: '51',
    icon: 'People',
    disableHover: false,
    isFavorite: false,
    href: '/customers',
    text: 'Klanten',
    isSeparator: false,
    permission: 'nav:customers',
  },
  {
    key: '52',
    icon: 'People',
    disableHover: true,
    isFavorite: false,
    href: '/payment-transactions',
    text: 'Betalingsschijven',
    isSeparator: false,
    permission: 'nav:customerPaymentTransactions',
  },
  {
    key: '53',
    icon: 'People',
    disableHover: true,
    isFavorite: false,
    href: '/contract-updates',
    text: 'Min- en meerwerken',
    isSeparator: false,
    permission: 'nav:customerContractUpdates',
  },
  {
    key: '54',
    icon: 'People',
    disableHover: true,
    isFavorite: false,
    href: '/customer-invoices',
    text: 'Uitgaande facturen',
    isSeparator: false,
    permission: 'nav:customerInvoices',
  },
  {
    key: '55',
    icon: 'People',
    disableHover: false,
    isFavorite: false,
    href: '/suppliers',
    text: 'Leveranciers',
    isSeparator: false,
    permission: 'nav:suppliers',
  },
  {
    key: '56',
    icon: 'People',
    disableHover: true,
    isFavorite: false,
    href: '/incoming-invoices',
    text: 'Inkomende facturen',
    isSeparator: false,
    permission: 'nav:customerInvoices',
  },
  {
    key: '57',
    icon: 'People',
    disableHover: true,
    isFavorite: false,
    href: '/cost-centers',
    text: 'Boekhoudkundige posten',
    isSeparator: false,
    permission: 'nav:costCenters',
  },
  {
    key: '6',
    icon: 'StackIndicator',
    disableHover: false,
    isFavorite: false,
    href: '',
    text: 'Organisatie',
    isSeparator: true,
    permissions: [
      'nav:employees',
      'nav:timeSheetEntries',
      'nav:cars',
      'nav:architects',
    ],
  },
  {
    key: '61',
    icon: 'People',
    disableHover: true,
    isFavorite: false,
    href: '/employees',
    text: 'Medewerkers',
    isSeparator: false,
    permission: 'nav:employees',
  },
  {
    key: '62',
    icon: 'People',
    disableHover: true,
    isFavorite: false,
    href: '/sales-reps',
    text: 'Verkopers',
    isSeparator: false,
    permission: 'nav:employees',
  },
  {
    key: '63',
    icon: 'People',
    disableHover: true,
    isFavorite: false,
    href: '/new-timesheet',
    text: 'Werkuren registreren',
    isSeparator: false,
    permission: 'nav:timeSheetEntries',
  },
  {
    key: '64',
    icon: 'People',
    disableHover: true,
    isFavorite: false,
    href: '/cars',
    text: 'Wagenpark',
    isSeparator: false,
    permission: 'nav:cars',
  },
  {
    key: '65',
    icon: 'People',
    disableHover: true,
    isFavorite: false,
    href: '/architects',
    text: 'Architecten',
    isSeparator: false,
    permission: 'nav:architects',
  },
  {
    key: '7',
    icon: 'StackIndicator',
    disableHover: false,
    isFavorite: false,
    href: '',
    text: 'Configuratie',
    isSeparator: true,
    permissions: [
      'nav:templates',
      'nav:purchaseOrders',
      'nav:suggestedValueCategories',
      'nav:taxCodes',
    ],
  },
  {
    key: '71',
    icon: 'People',
    disableHover: false,
    isFavorite: false,
    href: '/templates',
    text: 'Werf sjablonen',
    isSeparator: false,
    permission: 'nav:templates',
  },
  {
    key: '72',
    icon: 'People',
    disableHover: false,
    isFavorite: false,
    href: '/purchase-order-templates',
    text: 'Bestelbon sjablonen',
    isSeparator: false,
    permission: 'nav:purchaseOrders',
  },
  {
    key: '73',
    icon: 'People',
    disableHover: false,
    isFavorite: false,
    href: '/suggested-values',
    text: 'Voorgestelde waarden',
    isSeparator: false,
    permission: 'nav:suggestedValues',
  },
  /* {
    key: '74',
    icon: 'People',
    disableHover: false,
    isFavorite: false,
    href: '/tax_codes',
    text: 'BTW codes',
    isSeparator: false,
    permission: 'nav:taxCodes',
  }, */
];

const hasOneOfPermissions = (scopes: string[], permissions: string[]) => {
  for (let i = 0; i < scopes.length; i++) {
    if (permissions.includes(scopes[i])) {
      return true;
    }
  }

  return false;
};

const NavbarItemsList = () => {
  const { getAccessTokenSilently } = useAuth0();

  const [permissions, setPermissions] = useState<string[]>([]);

  useEffect(() => {
    getAccessTokenSilently().then(token => {
      if (token) {
        const decoded: any = jwt_decode(token);
        if (decoded && typeof decoded === 'object' && decoded.permissions) {
          setPermissions(decoded.permissions);
        }
      }
    });
  }, []);

  return (
    <Stack>
      {NavbarItems.map((item: INavbarItem) => {
        if (item.isSeparator && (item.permissions ? hasOneOfPermissions(item.permissions || [], permissions) : true)) {
          return (
            <Separator key={item.key} icon={returnFluentIcon(item.icon)}>
              {item.text}
            </Separator>
          );
        }
        if (permissions.includes(item.permission || '')) {
          return (
            <NavItem
              key={item.key}
              icon={returnFluentIcon(item.icon)}
              href={item.href}
              disableHover={item.disableHover}
              // isFavorite={item.isFavorite}
              navID='test'
            >
              {item.text}
            </NavItem>
          );
        }
        return null;
      })}
    </Stack>
  );
};

export default NavbarItemsList;
